

/** prefix for all api calls */
export const API_PREFIX = process.env.REACT_APP_API_PREFIX;

